import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { ViewAnnouncement as SingleAnnouncement } from '../../../components/view-announcement'

const ViewAnnouncement = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Announcements
                        </Heading>
                        <Breadcrumb
                            crumbs={['announcements', 'View']}
                        />
                        <SingleAnnouncement />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default ViewAnnouncement
